<header>
  <div class="wrap">
    <h2 class="title mb-4">{{ 'popins.closet-doors-structure-info.title' | translate }}</h2>

    <div class="modal-container shadow" *ngFor="let doorType of doorTypes">
      <h3 class="title" *ngIf="currentLang === 'fr'">{{ doorType.nameFr }}</h3>
      <h3 class="title" *ngIf="currentLang === 'en'">{{ doorType.nameEn }}</h3>
      <p class="subtitle" *ngIf="currentLang === 'fr'">{{ doorType.descriptionFr | translate }}</p>
      <p class="subtitle" *ngIf="currentLang === 'en'">{{ doorType.descriptionEn | translate }}</p>
      <p class="text">
        {{
          'popins.closet-doors-structure-info.ptext'
            | translate
              : {
                  minHeight: doorType.minHeight,
                  maxHeight: doorType.maxHeight,
                  minWidth: doorType.minWidth,
                  maxWidth: doorType.maxWidth,
                }
        }}
      </p>
    </div>

    <div class="header-actions">
      <button class="close" (click)="modalService.close()" title="{{ 'generic.close' | translate }}">
        <span class="icon-view-close" aria-hidden="true">
          <svg>
            <use xlink:href="assets/img/icons.svg#icon-view-close"></use>
          </svg>
        </span>
        <span>{{ 'generic.close' | translate }}</span>
      </button>
    </div>
  </div>
</header>
<div class="main">
  <footer class="popin-footer">
    <ng-casto-btn
      class="blue"
      [label]="'popins.closet-doors-structure-info.confirm' | translate"
      (click)="modalService.close()"></ng-casto-btn>
  </footer>
</div>
